<medrecord-auth-confirm-password-form
  [title]="'auth_reset_password_title'"
  [description]="'auth_reset_password_description'"
  (passwordSubmit)="onSubmit($event)"
></medrecord-auth-confirm-password-form>
